import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useEffect } from "react";

const LanguageRedirectAr = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    i18n.changeLanguage("ar");
    document.documentElement.lang = "ar";
    document.documentElement.dir = "rtl";
    navigate("/", { replace: true });
  }, [i18n, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="text-lg">جاري التبديل إلى العربية...</div>
        <div className="text-sm text-gray-500 mt-2">Switching to Arabic...</div>
      </div>
    </div>
  );
};

export default LanguageRedirectAr;
